import { jsx as r } from "react/jsx-runtime";
import o from "clsx";
import { Space as l } from "../Space/Space.js";
import "../../utils/sectionPreview.js";
import "react";
import { SvgStar as p } from "./SvgStar/SvgStar.js";
import '../../_assets/RatingStars.C3Yl5mao.css';const d = "_ratingStars_hmv36_44", f = "_ratingStar_hmv36_44", v = "_inherit_hmv36_58", t = {
  ratingStars: d,
  ratingStar: f,
  inherit: v,
  "slide-in-out": "_slide-in-out_hmv36_1",
  "fade-in-out": "_fade-in-out_hmv36_1"
}, u = 5, j = ({
  rating: i,
  maxRating: a = u,
  offset: m = 2,
  className: e,
  childClassName: _,
  inheritFontSize: c,
  theme: S = "new",
  thin: n,
  starClassName: h
}) => /* @__PURE__ */ r("div", { className: o(t.ratingStars, e), children: Array.from(Array(a).keys()).map((s, g) => /* @__PURE__ */ r(
  l,
  {
    right: a - 1 !== g && !n ? m : 0,
    className: o(_, t.ratingStar, c && t.inherit),
    children: /* @__PURE__ */ r(
      p,
      {
        item: s + 1,
        rating: i,
        className: h,
        theme: S,
        thin: n
      }
    )
  },
  `Rating_${i}_${s}`
)) });
export {
  j as RatingStars
};
